/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cases_Settings_Category_Removememberaria2Inputs */

const en_cases_settings_category_removememberaria2 = /** @type {(inputs: Cases_Settings_Category_Removememberaria2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name} from this category`)
};

/**
* | output |
* | --- |
* | "Remove {name} from this category" |
*
* @param {Cases_Settings_Category_Removememberaria2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_removememberaria2 = /** @type {((inputs: Cases_Settings_Category_Removememberaria2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Removememberaria2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_removememberaria2(inputs)
});
export { cases_settings_category_removememberaria2 as "cases_settings_category_removeMemberAria" }